import { matchPath } from 'react-router-dom';
import Cookies from 'js-cookie';

import { loggedUser as mockLoggedUser } from 'src/mocks';
import { config, routes, pagination } from 'src/constants';
import LocalStorageService from 'src/core/services/LocalStoregeService';
import { User } from 'src/core/models';

export const getLoggedUserData = () => {
  const additionalData = !config.isDevEnv && {
    currencyCode: Cookies.get('CK_CURRENCY_CODE'),
    displayLang: Cookies.get('CK_LANG_CODE'),
    countryCode: Cookies.get('CK_COUNTRY_CODE')
  };

  return config.isDevEnv || config.isTestEnv ? new User({ ...mockLoggedUser, ...additionalData }) :
    new User({
      ...LocalStorageService.getLoggedUser(),
      ...additionalData
    });
};

export const getUserCurrency = () => {
  const user = getLoggedUserData();

  return user.currencyCode;
};

export const isCSRUser = () => {
  const user = getLoggedUserData();

  return user.isCSR;
};

export const getUserFullName = () => {
  const user = getLoggedUserData();

  return `${user.firstName} ${user.lastName}`;
};

export const redirectToLogin = () => {
  window.location.pathname = '/account-center/signin-identifier.html';
};

const matchPaths = (path, currentLocation) => matchPath(currentLocation, {
  path: `${config.baseRoute}${path}`,
  exact: true,
  strict: false
});

export const isRouteMatching = (route) => {
  const currentLocation = window.location.pathname;
  const matchObj = matchPaths(route, currentLocation);

  return !!(matchObj && matchObj.isExact);
};

export const getRouteId = () => {
  const currentLocation = window.location.pathname;

  const result = routes.PATHS.map((path) => matchPaths(path, currentLocation))
    .find((matchObj) => !!(matchObj && matchObj.isExact));

  return result?.params?.id;
};

export const getPaginationConfig = (
  currentPage = pagination.INITIAL_PAGE,
  pageInterval = pagination.INITIAL_ROWS_PER_PAGE,
  resourceCount = 0
) => ({
  currentPage,
  totalPage: Math.ceil(resourceCount / pageInterval),
  totalItems: resourceCount,
  pageInterval
});

export const getSentenceCase = (string) => string.charAt(0).toUpperCase() +
  string.substr(1).toLowerCase();

export const getCountryCode = () => {
  const user = getLoggedUserData();

  return window?.iso_code || user?.countryCode;
};

export const isJapanUser = () => {
  const user = getLoggedUserData();
  const countryCode = user?.countryCode ? user.countryCode : window.iso_code;

  if (countryCode === 'jp' && user.locale === 'ja') { return true; }

  return false;
};
